module.exports = __webpack_public_path__ + "static/img/jisu.2a4aa0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/mobile/jisu.png
// module id = c6jD
// module chunks = 12